import Vue from 'vue';
import Router from 'vue-router';

import home from '@/components/home/home.vue';
import money from '@/components/home/money.vue';
import personalCenter from '@/components/personalCenter/personalCenter';
import train from '@/components/personalCenter/train';
import login from '@/components/login/login';
import comeIn from '@/components/home/comeIn';

import all from '@/components/home/money/all';
import choiceness from '@/components/home/money/choiceness';
import launch from '@/components/launch';
import jdDrainage from '@/components/jdDrainage';
import undercarriage from '@/components/undercarriage';
import urlView from '@/components/urlView';
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 说明：模块使用懒加载，后置参数为打包模块名称，若打包模块名称相同，即打包到同一个js，加载时大小有所不同

// 注册绑卡

const registerTwo = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/registerTwo')),
    'register'
  );
const registerThree = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/registerThree')),
    'register'
  );
const registerFour = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/registerFour')),
    'register'
  );
const registerBindCard = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/registerBindCard')),
    'register'
  );
const registerResult = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result')),
    'register'
  );
const tiedCard = r =>
  require.ensure(
    [],
    () => r(require('@/components/wallet/tiedCard')),
    'tiedCard'
  );
const tiedCardResult = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result')),
    'tiedCard'
  );

// 新注册
const registerNew = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/register/registerNew')),
    'register'
  );
const registerSetPwd = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/register/registerSetPwd')),
    'register'
  );
const registerResultNew = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result')),
    'register'
  );
// 新忘记登录密码
const forgetNew = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/forget/forgetNew')),
    'forget'
  );
const forgetSetPwd = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/forget/forgetSetPwd')),
    'forget'
  );
const forgetResult = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result')),
    'forget'
  );
// 新闻
// const news = r => require.ensure([], () => r(require('@/components/home/news')), 'news')

// 理财
// const all = r => require.ensure([], () => r(require('@/components/home/money/all')), 'weixin')
const collect = r =>
  require.ensure(
    [],
    () => r(require('@/components/home/money/collect')),
    'collect'
  );
// const choiceness = r => require.ensure([], () => r(require('@/components/home/money/choiceness')), 'weixin')
const search = r =>
  require.ensure(
    [],
    () => r(require('@/components/home/money/search')),
    'search'
  );

// 基金详情
const productDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/productDetail')),
    'product'
  );
const fundDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/fundDetail')),
    'product'
  );
const fundRate = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/fundRate')),
    'product'
  );
const fundManage = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/fundManage')),
    'product'
  );
const dividendTip = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/dividendRecord')),
    'product'
  );
const noDividend = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result')),
    'product'
  );
const legal = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/legal')),
    'product'
  );
const protfolio = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/protfolio')),
    'product'
  );
const historyList = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/historyList')),
    'product'
  );
const dividendRecord = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/dividendRecord')),
    'product'
  );

// 持有基金详情
const holdDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/holdDetail')),
    'holdDetail'
  );
const holdDividend = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/modifyDividend')),
    'holdDetail'
  );
const subscription = r =>
  require.ensure([], () => r(require('@/components/product/subscription')), 'subscription');

// 购买赎回
const buy = r =>
  require.ensure([], () => r(require('@/components/product/buy')), 'buy');
const buyResult = r =>
  require.ensure([], () => r(require('@/components/login/result2')), 'buyResult');
const tip = r =>
  require.ensure([], () => r(require('@/components/login/result')), 'tip');
const sale = r =>
  require.ensure([], () => r(require('@/components/product/sale')), 'sale');
const sale2 = r =>
  require.ensure([], () => r(require('@/components/product/sale2')), 'sale2');
// 大额详情
const purchase = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/purchase')),
    'product'
  );
// 大额转账确定
const surePurchase = r =>
  require.ensure(
    [],
    () => r(require('@/components/product/surePurchase')),
    'product'
  );
// 创金宝
const cjbao = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/cjbao')),
    'cjbao'
  );
// 零钱包
const changeBag = r =>
require.ensure(
  [],
  () => r(require('@/components/personalCenter/changeBag')),
  'changeBag'
);
// 零钱包2
const changeBagClone = r =>
require.ensure(
  [],
  () => r(require('@/components/personalCenter/changeBagClone')),
  'changeBagClone'
);
// 充值
const invest = r =>
require.ensure(
  [],
  () => r(require('@/components/personalCenter/invest')),
  'invest'
);
// 充值页面
const lqbSuccess = r =>
require.ensure(
  [],
  () => r(require('@/components/personalCenter/lqbSuccess')),
  'lqbSuccess'
);

// 充值页面
const docDialog = r =>
require.ensure(
  [],
  () => r(require('@/components/product/docDialog')),
  'docDialog'
);
// // 我的小目标
// const train = r =>
// require.ensure(
//   [],
//   () => r(require('@/components/personalCenter/train')),
//   'train'
// );
// 收益详情
const addProfit = r =>
require.ensure(
  [],
  () => r(require('@/components/personalCenter/addProfit')),
  'addProfit'
);
const fundAsset = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/fundAsset')),
    'fundAsset'
  );
const otherAsset = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/otherAsset')),
    'otherAsset'
  );
const setting = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/setting')),
    'setting'
  );

const cancelRegister = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/cancelRegister')),
    'cancelRegister'
  );
const registerCheck = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/registerCheck')),
    'registerCheck'
  );
const completeRegister = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/completeRegister')),
    'completeRegister'
  );


// 个人信息
const personal = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/personal')),
    'personal'
  );
const editMobile = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editMobile')),
    'personal'
  );
const editEmail = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editEmail')),
    'personal'
  );
const editPostalCode = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editPostalCode')),
    'personal'
  );
const editTel = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editTel')),
    'personal'
  );
const editAddress = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editAddress')),
    'personal'
  );
const editWork = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editWork')),
    'personal'
  );
const editWorkcompany = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editWorkcompany')),
    'personal'
  );
const editMes = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/personal/editMes')),
    'personal'
  );

// 常见问题
const commonQuestion = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/commonQuestion')),
    'commonQuestion'
  );

// 交易
const dealDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/deal/dealDetail')),
    'deal'
  );
const fundDeal = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/deal/fundDeal')),
    'deal'
  );
// 钱包
const myCard = r =>
  require.ensure(
    [],
    () => r(require('@/components/wallet/myCard')),
    'myCard'
  );
const cardDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/wallet/cardDetail')),
    'myCard'
  );
// 风评
const riskTest = r =>
  require.ensure(
    [],
    () => r(require('@/components/riskTest/riskTest')),
    'riskTest'
  );
const riskTestResult = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result2')),
    'riskTest'
  );
const agreement = r =>
  require.ensure(
    [],
    () => r(require('@/components/riskTest/agreement')),
    'agreement'
  );
  // 老用户已评测风险等级
const compliance = r =>
  require.ensure(
    [],
    () => r(require('@/components/riskTest/compliance')),
    'compliance'
  );
  // 风险提示列表
const risktips = r =>
  require.ensure(
    [],
    () => r(require('@/components/riskTest/risktips')),
    'risktips'
  );
const pdf = r =>
  require.ensure([], () => r(require('@/components/riskTest/pdf')), 'pdf');

// 定投
const timeInvestBuy = r =>
  require.ensure(
    [],
    () => r(require('@/components/timeInvest/timeInvestBuy')),
    'timeInvest'
  );
const timeInvestBuyResult = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result2')),
    'timeInvest'
  );
const timeInvestBuyTip = r =>
  require.ensure(
    [],
    () => r(require('@/components/login/result')),
    'timeInvest'
  );
const myTimeInvest = r =>
  require.ensure(
    [],
    () => r(require('@/components/timeInvest/myTimeInvest')),
    'timeInvest'
  );
const timeInvestDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/timeInvest/timeInvestDetail')),
    'timeInvest'
  );
// 修改密码
const modifyPwd = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/password/modify')),
    'modifyPwd'
  );
const verifyIdentity = r =>
  require.ensure(
    [],
    () => r(require('@/components/personalCenter/password/verifyIdentity')),
    'modifyPwd'
  );

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta: {
        title: '登录',
      },
    },
    {
      path: '/launch',
      name: 'launch',
      component: launch,
      meta: {
        title: '创金合信基金',
      },
    },
    {
      path: '/jdDrainage',
      name: 'jdDrainage',
      component: jdDrainage,
      meta: {
        title: '创金合信基金',
      },
    },
    {
      path: '/undercarriage',
      name: 'undercarriage',
      component: undercarriage,
      meta: {
        title: '内容已下架',
      },
    },
    {
      path: "/urlView",
      name: "urlView",
      component: urlView,
      meta: {
        title: "图片展示",
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '登录',
      },
    },
    {
      path: '/registerTwo',
      name: 'registerTwo',
      component: registerTwo,
      meta: {
        title: '上传身份证',
      },
    },
    {
      path: '/registerThree',
      name: 'registerThree',
      component: registerThree,
      meta: {
        title: '上传身份证',
      },
    },
    {
      path: '/registerFour',
      name: 'registerFour',
      component: registerFour,
      meta: {
        keepAlive: true,
        title: '个人资料',
      },
      children: [
        {
          path: 'result',
          name: 'registerResult',
          component: registerResult,
          meta: {
            title: '结果',
          },
        },
      ],
    },
    {
      path: '/registerBindCard',
      name: 'registerBindCard',
      component: registerBindCard,
      meta: {
        keepAlive: true,
        title: '绑定银行卡',
      },
    },
    {
      path: '/registerNew',
      name: 'registerNew',
      component: registerNew,
      meta: {
        title: '注册',
      },
    },
    {
      path: '/registerSetPwd',
      name: 'registerSetPwd',
      component: registerSetPwd,
      meta: {
        title: '注册',
      },
      children: [
        {
          path: 'result',
          name: 'registerResultNew',
          component: registerResultNew,
          meta: {
            title: '结果',
          },
        },
      ],
    },
    {
      path: '/forgetNew',
      name: 'forgetNew',
      component: forgetNew,
      meta: {
        title: '忘记密码',
      },
    },
    {
      path: '/forgetSetPwd',
      name: 'forgetSetPwd',
      component: forgetSetPwd,
      meta: {
        title: '忘记密码',
      },
      children: [
        {
          path: 'result',
          name: 'forgetResult',
          component: forgetResult,
          meta: {
            title: '结果',
          },
        },
      ],
    },
    // {path: '/news', name: 'news', component: news},
    {
      path: '/tiedCard',
      name: 'tiedCard',
      component: tiedCard,
      meta: {
        keepAlive: true,
        title: '绑卡',
      },
      children: [
        {
          path: 'result',
          name: 'tiedCardResult',
          component: tiedCardResult,
          meta: {
            title: '结果',
          },
        },
      ],
    },
    {
      path: '/comeIn',
      name: 'comeIn',
      component: comeIn,
      meta: {
        keepAlive: true,
      },
      children: [
        {
          path: 'home',
          name: 'home',
          component: home,
          meta: {
            keepAlive: true,
            title: '创金新基遇', //首页
          },
        },
        {
          path: 'money',
          name: 'money',
          component: money,
          meta: {
            keepAlive: true,
            title: '理财',
          },
          children: [
            {
              path: 'all',
              name: 'all',
              component: all,
              meta: {
                keepAlive: true,
                title: '理财',
              },
            },
            {
              path: 'collect',
              name: 'collect',
              component: collect,
              meta: {
                keepAlive: true,
                title: '理财',
              },
            },
            {
              path: 'choiceness',
              name: 'choiceness',
              component: choiceness,
              meta: {
                keepAlive: true,
                title: '理财',
              },
            },
            {
              path: 'search',
              name: 'search',
              component: search,
              meta: {
                title: '搜索',
              },
            },
          ],
        },
        {
          path: 'train',
          name: 'train',
          component: train,
          meta: {
            keepAlive: true,
            title: '小目标',
          },
        },
        {
          path: 'personalCenter',
          name: 'personalCenter',
          component: personalCenter,
          meta: {
            keepAlive: true,
            title: '个人中心',
          },
        },
      ],
    },
    {
      path: '/productDetail',
      name: 'productDetail',
      component: productDetail,
      meta: {
        keepAlive: false,
        title: '基金',
      },   
    
      children: [
        {
          path: 'fundDetail',
          name: 'fundDetail',
          component: fundDetail,
          meta: {
            keepAlive: true,
            title: '基金详情',
          },
        },
        {
          path: 'fundRate',
          name: 'fundRate',
          component: fundRate,
          meta: {
            keepAlive: false,
            title: '基金费率',
          },
        },
        {
          path: 'fundManage',
          name: 'fundManage',
          component: fundManage,
          meta: {
            keepAlive: true,
            title: '基金经理',
          },
        },
        {
          path: 'dividendRecord',
          name: 'dividendTip',
          component: dividendTip,
          meta: {
            keepAlive: true,
            title: '基金分红',
          },
        },
        {
          path: 'noDividend',
          name: 'noDividend',
          component: noDividend,
          meta: {
            keepAlive: true,
          },
        },
        {
          path: 'legal',
          name: 'legal',
          component: legal,
          meta: {
            title: '法律文件',
          },
        },
      ],
    },
    {
      path: '/holdDetail',
      name: 'holdDetail',
      component: holdDetail,
      meta: {
        title: '持仓基金',
      },
      children: [
        {
          path: 'dividend',
          name: 'holdDividend',
          component: holdDividend,
          meta: {
            title: '分红',
          },
        },
      ],
    },
    {
      path: '/protfolio',
      name: 'protfolio',
      component: protfolio,
      meta: {
        title: '投资比例',
      },
    },
    {
      path: '/historyList',
      name: 'historyList',
      component: historyList,
      meta: {
        title: '历史净值',
      },
    },
    {
      path: '/dividendRecord',
      name: 'dividendRecord',
      component: dividendRecord,
      meta: {
        title: '分红记录',
      },
    },
    {
      path: '/subscription',
      name: 'subscription',
      component: subscription,
      meta: {
        title: '基金',
      },
    },
    {
      path: '/buy',
      name: 'buy',
      component: buy,
      meta: {
        title: '买入',
        keepAlive: true,
      },
      children: [
        // {
        //   path: 'result',
        //   name: 'buyResult',
        //   component: buyResult,
        //   meta: {
        //     title: '交易详情',
        //   },
        // },
        {
          path: 'tip',
          name: 'tip',
          component: tip,
        },
      ],
    },
    {
      path: '/buyResult',
      name: 'buyResult',
      component: buyResult,
      meta: {
        title: '交易详情',
      },
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: purchase,
      meta: {
        title: '交易详情',
      },
    },
    {
      path: '/surePurchase',
      name: 'surePurchase',
      component: surePurchase,
      meta: {
        title: '大额转账服务',
      },
    },
    {
      path: '/commonQuestion',
      name: 'commonQuestion',
      component: commonQuestion,
      meta: {
        title: '常见问题',
      }
    },
    {
      path: '/sale',
      name: 'sale',
      component: sale,
      meta: {
        title: '赎回基金',
      },
      children: [
        {
          path: 'result',
          name: 'saleResult',
          component: resolve =>
            require(['@/components/login/result2.vue'], resolve),
          meta: {
            title: '结果',
          },
        },
      ],
    },
    {
      path: '/sale2',
      name: 'sale2',
      component: sale2,
      meta: {
        keepAlive: true,
        title: '赎回',
      },
    },
    {
      path: '/cjBao',
      name: 'cjBao',
      component: cjbao,
      meta: {
        keepAlive: true,
        title: '创金宝',
      },
    },
    {
      path: '/changeBag',
      name: 'changeBag',
      component: changeBag,
      meta: {
        keepAlive: true,
        title: '零钱包',
      },
    },
    {
      path: '/changeBagClone',
      name: 'changeBagClone',
      component: changeBagClone,
      meta: {
        keepAlive: true,
        title: '零钱包',
      },
    },
    {
      path: '/invest',
      name: 'invest',
      component: invest,
      meta: {
        keepAlive: true,
        title: '充值',
      },
    },
    {
      path: '/lqbSuccess',
      name: 'lqbSuccess',
      component: lqbSuccess,
      meta: {
        keepAlive: true,
        title: '交易成功',
      },
    },
    {
      path: '/docDialog',
      name: 'docDialog',
      component: docDialog,
      meta: {
        keepAlive: true,
        title: '',
      },
    },
    {
      path: '/addProfit',
      name: 'addProfit',
      component: addProfit,
      meta: {
        keepAlive: true,
        title: '收益详情',
      },
    },
    // {
    //   path: '/train',
    //   name: 'train',
    //   component: train,
    //   meta: {
    //     title: '我的小目标',
    //   },
    // },
    {
      path: '/fundAsset',
      name: 'fundAsset',
      component: fundAsset,
      meta: {
        keepAlive: true,
        title: '基金资产',
      },
    },
    {
      path: '/otherAsset',
      name: 'otherAsset',
      component: otherAsset,
      meta: {
        keepAlive: true,
        title: '其他资产',
      },
    },
    {
      path: '/setting',
      name: 'setting',
      component: setting,
      meta: {
        keepAlive: false,
        title: '设置',
      },
    },
    {
      path: '/cancelRegister',
      name: 'cancelRegister',
      component: cancelRegister,
      meta: {
        keepAlive: true,
        title: '注销登录账号',
      },
    },
    {
      path: '/registerCheck',
      name: 'registerCheck',
      component: registerCheck,
      meta: {
        keepAlive: true,
        title: '注销登录账号',
      },
    },
    {
      path: '/completeRegister',
      name: 'completeRegister',
      component: completeRegister,
      meta: {
        keepAlive: true,
        title: '注销登录账号',
      },
    },
    {
      path: '/personal',
      name: 'personal',
      component: personal,
      meta: {
        keepAlive: false,
        title: '个人信息',
      },
      children: [
        {
          path: 'editMobile',
          name: 'editMobile',
          component: editMobile,
          meta: {
            title: '个人信息',
          },
        },
        {
          path: 'editEmail',
          name: 'editEmail',
          component: editEmail,
          meta: {
            title: '个人信息',
          },
        },
        {
          path: 'editPostalCode',
          name: 'editPostalCode',
          component: editPostalCode,
          meta: {
            title: '个人信息',
          },
        },
        {
          path: 'editTel',
          name: 'editTel',
          component: editTel,
          meta: {
            title: '个人信息',
          },
        },
        {
          path: 'editWork',
          name: 'editWork',
          component: editWork,
          meta: {
            title: '个人信息',
          },
        },
        {
          path: 'editWorkcompany',
          name: 'editWorkcompany',
          component: editWorkcompany,
          meta: {
            title: '个人信息',
          },
        },
        {
          path: 'editAddress',
          name: 'editAddress',
          component: editAddress,
          meta: {
            title: '个人信息',
          },
        },
        {
          path: 'editMes',
          name: 'editMes',
          component: editMes,
          meta: {
            title: '个人信息',
          },
        },
      ],
    },
    {
      path: '/dealDetail',
      name: 'dealDetail',
      component: dealDetail,
      meta: {
        title: '交易记录',
      },
    },
    {
      path: '/fundDeal',
      name: 'fundDeal',
      component: fundDeal,
      meta: {
        title: '交易记录',
      },
    },
    {
      path: '/myCard',
      name: 'myCard',
      component: myCard,
      meta: {
        title: '银行卡',
      },
      children: [
        {
          path: 'cardDetail',
          name: 'cardDetail',
          component: cardDetail,
        },
      ],
    },
    {
      path: '/riskTest',
      name: 'riskTest',
      component: riskTest,
      meta: {
        title: '风险测评',
      },
      children: [
        {
          path: 'result',
          name: 'riskTestResult',
          component: riskTestResult,
          meta: {
            title: '结果',
          },
        },
      ],
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta: {
        title: '协议',
      },
    },
    {
      path: '/compliance',
      name: 'compliance',
      component: compliance,
      meta: {
        title: '结果',
      },
      // beforeEnter:(to, from, next) => {
      //   alert(to.name)  
      //   if(to.name === 'riskTest'){
      //   }
      //   next()
      // }
    },
    {
      path: '/risktips',
      name: 'risktips',
      component: risktips,
      meta: {
        title: '风险提示',
      },
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: pdf,
      meta: {
        title: '购买前请阅读',
      },
    },
    {
      path: '/timeInvestBuy',
      name: 'timeInvestBuy',
      component: timeInvestBuy,
      meta: {
        title: '定投基金',
        keepAlive: true,
      },
      children: [
        {
          path: 'result',
          name: 'timeInvestBuyResult',
          component: timeInvestBuyResult,
          meta: {
            title: '结果',
          },
        },
        {
          path: 'tip',
          name: 'timeInvestBuyTip',
          component: timeInvestBuyTip,
        },
      ],
    },
    {
      path: '/myTimeInvest',
      name: 'myTimeInvest',
      component: myTimeInvest,
      meta: {
        title: '我的定投',
      },
      children: [
        {
          path: 'timeInvestDetail',
          name: 'timeInvestDetail',
          component: timeInvestDetail,
          meta: {
            title: '定投详情',
          },
        },
      ],
    },
    {
      path: '/modifyPwd',
      name: 'modifyPwd',
      component: modifyPwd,
      meta: {
        title: '修改密码',
      },
    },
    {
      path: '/verifyIdentity',
      name: 'verifyIdentity',
      component: verifyIdentity,
      meta: {
        title: '验证身份',
      },
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js